import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  DatePicker,
  Select,
  Modal,
  message,
} from "antd";
import moment from "moment";
import MedicalService from "../../../../../Services/MedicalHistoryService";
import ChronicConditionService from "../../../../../Services/ChronicConditionService";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";

function AddVaccination(props) {
  const [form] = Form.useForm();
  const activePatient = JSON.parse(sessionStorage.getItem("patient"));
  const patientCode = activePatient?.patientId;
  const [chronicCode, setChronicCode] = useState([]);
  const [vaccineDesc, setVaccineDesc] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [givenDate, setGivenDate] = useState();
  const formRef = useRef();

  const handleCancel = () => {
    props.onClose();
  };

  const handleDate = (date, dateString) => {
    if (dateString) {
      const constructedTime = dateString + " " + "00:00:00";
      setGivenDate(constructedTime);
    } else {
      setGivenDate("");
    }
  };

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handlehealthChange = (value, desc) => {
    setVaccineDesc(desc.description);
  };
  const vaccines = [
    { description: "Influenza(Flu)", code: "Influenza(Flu)" },
    {
      description: "Tetanus, Diphtheria, Pertussis (Td, Tdap)",
      code: "Tetanus, Diphtheria, Pertussis(Td,Tdap)",
    },
    { description: "Zoster (Shingles)", code: "Zoster(Shingles)" },
    {
      description: "Pneumococcal (PCV13, PPSV23)",
      code: "Pneumococcal(PCV13,PPSV23)",
    },
    { description: "Varicella (Chickenpox)", code: "Varicella(Chickenpox)" },
    {
      description: "Human Papillomavirus (HPV)",
      code: "Human Papillomavirus(HPV)",
    },
    {
      description: "Measles, Mumps, Rubella (MMR)",
      code: "Measles, Mumps, Rubella (MMR)",
    },
    { description: "Meningococcal", code: "Meningococcal" },
    { description: "Hepatitis A", code: "Hepatitis A" },
    { description: "Hepatitis B", code: "Hepatitis B" },
    {
      description: "Haemophilus influenzae type b (Hib)",
      code: "Haemophilus influenzae type b (Hib)",
    },
  ];

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const { pastInfo } = formRef.current.getFieldValue();
    if (!pastInfo || !givenDate) {
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }

    let payload = {
      account_Id: userData?.user?.account_Id,
      clinic_Id: userData?.user?.clinic_Id,
      userId: userData?.user?.userId,
      createdDate: constructedTime,
      givenDate: givenDate,
      createdBy: userData?.user?.userId,
      modifiedBy: userData?.user?.userId,
      status: 1,
      patientId: patientCode,
      description: vaccineDesc,
      modifiedDate: constructedTime,
      createdName: userData?.user?.firstName,
      fromDate: null,
      toDate: null,
    };

    try {
      const response = await MedicalService.AddImmunisationHistory(payload);
      if (response.data === 1) {
        let payload = {
          patientId: patientCode,
          // account_Id: userData?.user?.account_Id,
          // clinic_Id: userData?.user?.clinic_Id,
          userId:
            props.permissionData === null || props.permissionData === "N"
              ? userData?.user?.userId
              : "",
          status: 1,
        };
        MedicalHistoryService.PatientImmunisation(payload).then((result) => {
          props.handleLatestUpdate(result.data);
          setIsLoading(false);
          formRef.current.resetFields();
          props.onClose();
        });
      }
    } catch (e) {
      console.error(e);
      message.error(e?.response?.data?.message);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Immunisation <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="pastInfo"
            >
              <Select
                style={{ width: "100%" }}
                onChange={handlehealthChange}
                placeholder="Select"
                options={vaccines.map((ele) => ({
                  value: ele.code,
                  description: ele.description,
                  label: ele.description,
                  key: ele.code,
                }))}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Date<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="givenDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleCancel}
            className="border-brand-primaryColor bg-white border rounded text-brand-primaryColor text-sm px-6 py-1.5"
          >
            Cancel
          </button>
          <button
            disabled={isLoading}
            onClick={onFinish}
            className="bg-brand-primaryColor rounded px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}

export default AddVaccination;
